export default __webpack_public_path__ + "static/media/SpotifyLogo.56a27899.png";